export default {
  title: "欢迎登录典枢",
  tip: "先验后买，所见即所得",
  scanCode: "微信扫码",
  refreshCode: "刷新二维码",
  scanCodeSuccess: "扫码成功",
  protocolTips: "未注册的微信号将自动创建典枢账号",
  protocolTips2: "注册、登录即代表同意",
  userProtocol: "《用户协议》",
  privacyPolicy: "《隐私政策》",
  protocolSplitter: "和",
  setPrivateKeyTips:
    "欢迎加入典枢！为了保障您的账户安全，请设置授权密码，以便您进行后续的数据交易。感谢您的配合！",
  bindPhoneNumber: "绑定手机号码",
  bindPhoneDescription:
    "您尚未绑定手机号码，请先绑定手机号码以便您后续找回授权密码或接收通知。",
  bindPhoneDescription2:
    "你尚未绑定手机号码，需绑定手机号码后才可以修改授权密码。",
  phoneNumberPlaceholder: "手机号码",
  verificationCodePlaceholder: "6位数字验证码",
  loginButton: "登录",
  nextButton: "下一步",
  phoneNumberRequired: "请输入手机号码",
  invalidPhoneNumber: "请输入正确的手机号码格式",
  verificationCodeRequired: "请输入验证码",
  invalidVerificationCode: "验证码必须为6位数字",
  resendCodeCountdown: "{seconds}秒后重新获取",
  invalidEmail: "请输入有效的邮箱地址",
  smsVerificationCodeSent: "验证码已发送到您的手机",
  emailVerificationCodeSent: "验证码已发送到您的邮箱",
  getVerificationCode: "获取验证码",
  verificationCodeSent: "验证码已发送",
  agreementRequired: "请阅读并同意《用户协议》和《隐私政策》",
  verificationCodeNotSent: "请先获取验证码",
  phoneNumberBindSuccess: "手机号码绑定成功",
  networkError: "网络异常，请检查您的网络",
  failedToGetVerificationCode: "发送失败，请稍后重试",
  productName: "典枢",
  casButtonText: "登录或注册",
  casDescription: "",
  openingClient: "正在打开客户端...",
  openManuallyTip: "如果客户端没有自动打开，请点击下方按钮打开客户端",
  openClientButton: "打开客户端",
};
